import './lib/validation-runtime'
// Before Sentry starts, so no telemetry ever sees a setup or reset link's token.
import './lib/access-link-token'
import './lib/sentry'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { queryClient } from './api/hooks'
import { router } from './router'
import { ThemeProvider } from '@/components/theme-provider'
import { CurrentShowProvider } from '@/context/current-show'
import { LabelPrinterProvider } from '@/context/label-printer'
import { ErrorBoundaryFallback } from '@/components/error-boundary'

// Import global styles
import './styles/global.css'

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found')
}

createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="honey-show-theme">
      <QueryClientProvider client={queryClient}>
        <CurrentShowProvider>
          <LabelPrinterProvider>
            <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
              <RouterProvider router={router} />
            </Sentry.ErrorBoundary>
          </LabelPrinterProvider>
        </CurrentShowProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
